import { MediaMatcher } from "@angular/cdk/layout";
import { Component, OnInit, ViewEncapsulation, inject } from "@angular/core";
import { IPopoverOptions, PopoverRef, PopoverService } from "@tylertech/forge-angular";
import { WINDOW } from "@tylertech/shared-module";
import { SettingLookupOption } from "@tylertech/tyler-api-types";
import { BrowserService, ConnectionSettings, SecurityService } from "../../../services";
import { ConnGroupPopoverComponent } from "./connGroupPopover.component";
import { ConnGroupSettings, ConnGroupStorageKey } from "./model";

@Component({
    selector: "conn-group-action",
    templateUrl: "./connGroupAction.tmpl.html",
    styleUrls: [
        "./connGroupAction.component.scss"
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConnGroupActionComponent implements OnInit
{
    private readonly forgePopoverService = inject(PopoverService);
    private readonly window = inject<globalThis.Window>(WINDOW);
    private readonly $securityService = inject(SecurityService);
    private readonly media = inject(MediaMatcher);
    private readonly $browserService = inject(BrowserService);

    protected popoverRef?: PopoverRef<ConnGroupPopoverComponent>;

    updateConnGroupDefault: boolean = false;
    connGroupIdToUpdate: string;
    departmentIdToUpdate: string;
    PrevConnGroupID: string = "";
    connGroupDisabled: boolean = false;
    departmentDisabled: boolean = false;

    ngOnInit()
    {
        if (!this.ConnGroupID
            && this.$securityService.hasSetting(ConnectionSettings.ConnGroup))
        {
            const connGroupIdSetting = this.$securityService.Settings[ConnectionSettings.ConnGroup] as SettingLookupOption;
            this.window.sessionStorage.setItem(ConnGroupStorageKey.ConnGroupId, connGroupIdSetting.Value);
        }
    }

    private get ConnGroupID(): string
    {
        return this.window.sessionStorage.getItem(ConnGroupStorageKey.ConnGroupId);
    }

    get ConnGroupList(): Array<SettingLookupOption>
    {

        if (!this.$securityService.hasSetting(ConnGroupSettings.ConnGroupList))
        {
            return null;
        }

        return this.$securityService.Settings[ConnGroupSettings.ConnGroupList] as Array<SettingLookupOption>;
    }

    get ConnGroup(): string
    {
        return this.ConnGroupList.find(x => x.Value === this.ConnGroupID)?.Display ?? "";
    }

    get Department(): string
    {
        if (!this.$securityService.hasSetting(ConnectionSettings.Department))
        {
            return null;
        }

        const departmentSetting = this.$securityService.Settings[ConnectionSettings.Department] as SettingLookupOption;
        return departmentSetting.Display;
    }

    get popupOpen(): boolean
    {
        return !!this.popoverRef;
    }

    get useIconButton(): boolean
    {
        return this.media.matchMedia("(max-width: 1279px)").matches;
    }

    get showDepartment(): boolean
    {
        return this.$browserService.isBrowserFontSettingDefault;
    }

    onClick($event: Event): void
    {
        const anchorElement = $event.target as HTMLElement;
        const popupOptions: IPopoverOptions = {
            anchorElement,
            placement: "bottom",
            // NOTE: PopoverDirective.forgePopoverCloseOnBlur mapped the inverse of the value to this.
            persistent: false,
            // TODO: there is no attribute or @Input defined in PopoverDirective for `forgePopoverCloseOnEscape` that was used in the template....
        };

        this.popoverRef = this.forgePopoverService.show(ConnGroupPopoverComponent, popupOptions);

        this.popoverRef.afterClosed
            .subscribe(() =>
            {
                anchorElement.focus();
            });
    }
}
